export default "__VITE_ASSET__CP$WbUJb__"